import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NewsPost } from 'apollo/generated/types';
import getApiLanguage from 'i18n/apiLanguage';

const GET_NEWS_POSTS = gql`
  query getNewsPost($input: GetNewsPostInput!) {
    getNewsPost(input: $input) {
      id
      title
      contents {
        content
        order
      }
      readTime
      coverImage {
        url
        id
        caption
      }
      mainImage {
        url
        id
        caption
      }
      closingImages {
        url
        id
        caption
      }
      publicationDate
      viewCount
      status
      featured
      author
      newsPostRecommendations {
        id
        title
        coverImage {
          url
          id
        }
      }
    }
  }
`;
const useGetNewsPostQuery = (id: string) => {
  const { i18n } = useTranslation();

  return useQuery<{ getNewsPost: NewsPost }>(GET_NEWS_POSTS, {
    variables: { input: { id, language: getApiLanguage(i18n.language) } },
  });
};
export default useGetNewsPostQuery;
